module.exports = __webpack_public_path__ + "img/message-middle-top.f111b92a.svg";